"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cow Health Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.61
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.SymptomTypeEnum = exports.SicknessTypeEnum = exports.SeverityLevelEnum = exports.IHealthCaseStatusEnum = exports.HealthCaseSymptomTypeEnum = exports.HealthCaseSymptomPrefixEnum = exports.HealthCaseStatusEnum = exports.HealthCaseEventTypeEnum = exports.HealthCaseEventOriginEnum = exports.DurationOfIllnessGroupingEnum = exports.DiagnosisTypeEnum = exports.CowHealthTimelineEntryEventTypeEnum = exports.CowHealthStatusChangeEventTypeEnum = exports.CowFlaggedEventUpdateTypeEnum = exports.CalvingRecoveryStateEnum = exports.BehaviourIntervalPeriodEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.BehaviourIntervalPeriodEnum = {
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CalvingRecoveryStateEnum = {
    WELL: 'RECOVERING_WELL',
    POORLY: 'RECOVERING_POORLY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowFlaggedEventUpdateTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHealthStatusChangeEventTypeEnum = {
    FLAGGED: 'FLAGGED',
    UNFLAGGED: 'UNFLAGGED',
    CONFIRMED_AS_SICK: 'CONFIRMED_AS_SICK',
    SICKNESS_RESOLVED: 'SICKNESS_RESOLVED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHealthTimelineEntryEventTypeEnum = {
    FLAGGED: 'FLAGGED',
    UNFLAGGED: 'UNFLAGGED',
    CONFIRMED: 'CONFIRMED',
    CONFIRMED_CANCELLED: 'CONFIRMED_CANCELLED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DiagnosisTypeEnum = {
    MASTITIS: 'MASTITIS',
    MYCOPLASMA_BOVIS: 'MYCOPLASMA_BOVIS',
    LAMENESS: 'LAMENESS',
    ACIDOSIS: 'ACIDOSIS',
    BLOAT: 'BLOAT',
    BVD_VIRUS: 'BVD_VIRUS',
    CALVING_COMPLICATION: 'CALVING_COMPLICATION',
    COCCIDIOSIS: 'COCCIDIOSIS',
    COPPER_DEFICIENCY: 'COPPER_DEFICIENCY',
    DOWN_COW: 'DOWN_COW',
    ENDOMETRITIS: 'ENDOMETRITIS',
    FACIAL_ECZEMA: 'FACIAL_ECZEMA',
    GRASS_STAGGERS: 'GRASS_STAGGERS',
    HEAT_STRESS: 'HEAT_STRESS',
    JOHNE_S_DISEASE: 'JOHNE_S_DISEASE',
    KETOSIS: 'KETOSIS',
    LEPTOSPIROSIS: 'LEPTOSPIROSIS',
    LEFT_DISPLACED_ABOMASUM: 'LEFT_DISPLACED_ABOMASUM',
    MILK_FEVER: 'MILK_FEVER',
    NITRATE_POISONING: 'NITRATE_POISONING',
    PERITONITIS: 'PERITONITIS',
    RIGHT_DISPLACED_ABOMASUM: 'RIGHT_DISPLACED_ABOMASUM',
    RETAINED_FOETAL_MEMBRANE: 'RETAINED_FOETAL_MEMBRANE',
    RYEGRASS_STAGGERS: 'RYEGRASS_STAGGERS',
    SALMONELLA: 'SALMONELLA',
    SCOURS: 'SCOURS',
    SODIUM_DEFICIENCY: 'SODIUM_DEFICIENCY',
    THEILERIA: 'THEILERIA',
    TRACE_ELEMENTS: 'TRACE_ELEMENTS',
    OTHER: 'OTHER',
    NO_ILLNESS_OBSERVED: 'NO_ILLNESS_OBSERVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DurationOfIllnessGroupingEnum = {
    DAYS: 'DAYS'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthCaseEventOriginEnum = {
    HEALTH_MODEL: 'HEALTH_MODEL',
    USER: 'USER',
    MONITORING_SERVICE: 'MONITORING_SERVICE',
    COW_HEALTH_SERVICE: 'COW_HEALTH_SERVICE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthCaseEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthCaseStatusEnum = {
    RECENTLY_DIAGNOSED: 'RECENTLY_DIAGNOSED',
    RECOVERED: 'RECOVERED',
    NEEDS_ATTENTION: 'NEEDS_ATTENTION',
    CHECK_IMMEDIATELY: 'CHECK_IMMEDIATELY',
    WATCHLIST: 'WATCHLIST',
    HISTORY: 'HISTORY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthCaseSymptomPrefixEnum = {
    LOW: 'LOW',
    VERY_LOW: 'VERY_LOW',
    HIGH: 'HIGH',
    VERY_HIGH: 'VERY_HIGH'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthCaseSymptomTypeEnum = {
    RESTING: 'RESTING',
    RUMINATING: 'RUMINATING',
    GRAZING: 'GRAZING',
    IMMOBILE: 'IMMOBILE',
    ABNORMALLY_LONG_RESTING_BOUT: 'ABNORMALLY_LONG_RESTING_BOUT',
    EXTREMELY_LOW_MOVEMENT: 'EXTREMELY_LOW_MOVEMENT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IHealthCaseStatusEnum = {
    OPEN: 'OPEN',
    RESOLVED: 'RESOLVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SeverityLevelEnum = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    UNKNOWN: 'UNKNOWN',
    NOT_APPLICABLE: 'NOT_APPLICABLE',
    CRITICAL: 'CRITICAL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SicknessTypeEnum = {
    MASTITIS: 'MASTITIS',
    MYCOPLASMA_BOVIS: 'MYCOPLASMA_BOVIS',
    LAMENESS: 'LAMENESS',
    ACIDOSIS: 'ACIDOSIS',
    BLOAT: 'BLOAT',
    BVD_VIRUS: 'BVD_VIRUS',
    CALVING: 'CALVING',
    CALVING_COMPLICATION: 'CALVING_COMPLICATION',
    COCCIDIOSIS: 'COCCIDIOSIS',
    COPPER_DEFICIENCY: 'COPPER_DEFICIENCY',
    DOWN_COW: 'DOWN_COW',
    ENDOMETRITIS: 'ENDOMETRITIS',
    FACIAL_ECZEMA: 'FACIAL_ECZEMA',
    GRASS_STAGGERS: 'GRASS_STAGGERS',
    HEAT_STRESS: 'HEAT_STRESS',
    JOHNE_S_DISEASE: 'JOHNE_S_DISEASE',
    KETOSIS: 'KETOSIS',
    LEPTOSPIROSIS: 'LEPTOSPIROSIS',
    LEFT_DISPLACED_ABOMASUM: 'LEFT_DISPLACED_ABOMASUM',
    MILK_FEVER: 'MILK_FEVER',
    NITRATE_POISONING: 'NITRATE_POISONING',
    PERITONITIS: 'PERITONITIS',
    RIGHT_DISPLACED_ABOMASUM: 'RIGHT_DISPLACED_ABOMASUM',
    RETAINED_FOETAL_MEMBRANE: 'RETAINED_FOETAL_MEMBRANE',
    RYEGRASS_STAGGERS: 'RYEGRASS_STAGGERS',
    SALMONELLA: 'SALMONELLA',
    SCOURS: 'SCOURS',
    SODIUM_DEFICIENCY: 'SODIUM_DEFICIENCY',
    THEILERIA: 'THEILERIA',
    TRACE_ELEMENTS: 'TRACE_ELEMENTS',
    OTHER: 'OTHER'
};
/**
 * The symptom triggering an alert. Symptoms measuring decreases in a feature look at one day of data, while prolonged decrease symptoms look at four days, but with a more sensitive threshold.
 * @export
 * @enum {string}
 */
exports.SymptomTypeEnum = {
    DECREASED_MOVEMENT_AND_GRAZING: 'DECREASED_MOVEMENT_AND_GRAZING',
    PROLONGED_DECREASED_MOVEMENT_AND_GRAZING: 'PROLONGED_DECREASED_MOVEMENT_AND_GRAZING',
    PROLONGED_DECREASED_GRAZING: 'PROLONGED_DECREASED_GRAZING',
    DECREASED_RUMINATION: 'DECREASED_RUMINATION',
    DECREASED_RUMINATION_AND_MOVEMENT: 'DECREASED_RUMINATION_AND_MOVEMENT',
    PROLONGED_DECREASED_RUMINATION: 'PROLONGED_DECREASED_RUMINATION',
    PROLONGED_DECREASED_RUMINATION_AND_MOVEMENT: 'PROLONGED_DECREASED_RUMINATION_AND_MOVEMENT',
    IMMOBILE: 'IMMOBILE',
    ABNORMALLY_LONG_NOT_RUMINATING_BOUT: 'ABNORMALLY_LONG_NOT_RUMINATING_BOUT',
    ABNORMALLY_LONG_RESTING_BOUT: 'ABNORMALLY_LONG_RESTING_BOUT',
    ABNORMALLY_LONG_RESTING_AND_NOT_RUMINATING_BOUT: 'ABNORMALLY_LONG_RESTING_AND_NOT_RUMINATING_BOUT',
    EXTREMELY_LOW_MOVEMENT: 'EXTREMELY_LOW_MOVEMENT'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Deletes a manually created health-case that is unknown to the model
         * @param {string} healthCaseId The ID of the health case to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthCase: function (healthCaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'healthCaseId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteManualHealthCase', 'healthCaseId', healthCaseId);
                    localVarPath = "/cow-health/health-case/{healthCaseId}/delete"
                        .replace("{".concat("healthCaseId", "}"), encodeURIComponent(String(healthCaseId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a manually created cow health timeline
         * @param {string} timelineEntryid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthTimelineEntry: function (timelineEntryid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'timelineEntryid' is not null or undefined
                    (0, common_1.assertParamExists)('deleteManualHealthTimelineEntry', 'timelineEntryid', timelineEntryid);
                    localVarPath = "/cow-health/timeline";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timelineEntryid !== undefined) {
                        localVarQueryParameter['timelineEntryid'] = timelineEntryid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Flags a cow as sick through system report. This is the old method and will be deprecated in favor of flagSickCow
         * @param {ICowFlaggedEventDTO} [iCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        flagCow: function (iCowFlaggedEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/flag";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCowFlaggedEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Flags a cow as sick from the Health 2.0 model
         * @param {ISickCowFlaggedEventDTO} [iSickCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagSickCow: function (iSickCowFlaggedEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/flagSickCow";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSickCowFlaggedEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Gets the number of health cases that the farmer needs to check immediately
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckImmediatelyCount: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/get-check-immediately-count";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve list of cow behaviour total minutes for passed in list of cattleIds
         * @param {ICowBehaviourTotalMinutesForCattleIdsRequestDTO} iCowBehaviourTotalMinutesForCattleIdsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowBehaviourTotalMinutesForCattleIds: function (iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCowBehaviourTotalMinutesForCattleIdsRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('getCowBehaviourTotalMinutesForCattleIds', 'iCowBehaviourTotalMinutesForCattleIdsRequestDTO', iCowBehaviourTotalMinutesForCattleIdsRequestDTO);
                    localVarPath = "/cow-health/cow-behaviour-total-minutes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCowBehaviourTotalMinutesForCattleIdsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow. Will be deprecated and replaced with /windowed-health-behaviour in June 2023
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthBehaviour: function (cattleId, from, to, intervalPeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthBehaviour', 'cattleId', cattleId);
                    // verify required parameter 'from' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthBehaviour', 'from', from);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthBehaviour', 'to', to);
                    localVarPath = "/cow-health/{cattleId}/health-behaviour"
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    if (intervalPeriod !== undefined) {
                        localVarQueryParameter['intervalPeriod'] = intervalPeriod;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves health cases for a cow
         * @param {string} cattleId The ID of the cow to retrieve health cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthCases: function (cattleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthCases', 'cattleId', cattleId);
                    localVarPath = "/cow-health/{cattleId}/health-cases"
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow aggregated in windows of time
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthWindowedBehaviour: function (cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthWindowedBehaviour', 'cattleId', cattleId);
                    // verify required parameter 'from' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthWindowedBehaviour', 'from', from);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthWindowedBehaviour', 'to', to);
                    // verify required parameter 'windowSizeMilliseconds' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthWindowedBehaviour', 'windowSizeMilliseconds', windowSizeMilliseconds);
                    // verify required parameter 'windowSlideMilliseconds' is not null or undefined
                    (0, common_1.assertParamExists)('getCowHealthWindowedBehaviour', 'windowSlideMilliseconds', windowSlideMilliseconds);
                    localVarPath = "/cow-health/{cattleId}/windowed-health-behaviour"
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    if (windowSizeMilliseconds !== undefined) {
                        localVarQueryParameter['windowSizeMilliseconds'] = windowSizeMilliseconds;
                    }
                    if (windowSlideMilliseconds !== undefined) {
                        localVarQueryParameter['windowSlideMilliseconds'] = windowSlideMilliseconds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves cows currently in calving recovery
         * @param {string} [cattleId] The ID of the cow to retrieve calving recovery data for
         * @param {boolean} [allResults] Defaults to false if undefined. If true then send all results with no 21 day cut off
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsInCalvingRecovery: function (cattleId, allResults, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/calving-recovery";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (allResults !== undefined) {
                        localVarQueryParameter['allResults'] = allResults;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Gets the current health cases that are both diagnosed and not yet diagnosed in a summary form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSummaryHealthCases: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/get-current-summary-health-cases";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve sick cows grouped by duration of illness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDurationOfIllnessHealthTimeline: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/timeline/duration-of-illness";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Fetches the latest state of a health case
         * @param {string} healthCaseId The ID of the health case to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCaseById: function (healthCaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'healthCaseId' is not null or undefined
                    (0, common_1.assertParamExists)('getHealthCaseById', 'healthCaseId', healthCaseId);
                    localVarPath = "/cow-health/health-case/{healthCaseId}"
                        .replace("{".concat("healthCaseId", "}"), encodeURIComponent(String(healthCaseId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves sick cow timeline entries.
         * @param {number} [limit] Number of timeline entries in response. If less than this number returned, more statuses do not exist.
         * @param {number} [offset]
         * @param {string} [cattleId] Limit the results to a particular cattle id
         * @param {Array<SicknessTypeEnum>} [sicknessTypes] Limit the results to particular sickness types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthTimeline: function (limit, offset, cattleId, sicknessTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/timeline";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (sicknessTypes) {
                        localVarQueryParameter['sicknessTypes'] = sicknessTypes;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Gets the historical health cases in a paged response
         * @param {number} [currentOffset]
         * @param {any} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricHealthCases: function (currentOffset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/get-historic-health-cases";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (currentOffset !== undefined) {
                        localVarQueryParameter['currentOffset'] = currentOffset;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthBehaviour: function (mobId, from, to, intervalPeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mobId' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthBehaviour', 'mobId', mobId);
                    // verify required parameter 'from' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthBehaviour', 'from', from);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthBehaviour', 'to', to);
                    localVarPath = "/cow-health/mobs/{mobId}/health-behaviour"
                        .replace("{".concat("mobId", "}"), encodeURIComponent(String(mobId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    if (intervalPeriod !== undefined) {
                        localVarQueryParameter['intervalPeriod'] = intervalPeriod;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob in sliding windows.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {number} [lowerRangePercentile] Lower boundary percentile of the cows in the mob to calculate for the rangeLower
         * @param {number} [upperRangePercentile] Upper boundary percentile of the cows in the mob to calculate for the rangeUpper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthWindowedBehaviour: function (mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mobId' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthWindowedBehaviour', 'mobId', mobId);
                    // verify required parameter 'from' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthWindowedBehaviour', 'from', from);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthWindowedBehaviour', 'to', to);
                    // verify required parameter 'windowSizeMilliseconds' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthWindowedBehaviour', 'windowSizeMilliseconds', windowSizeMilliseconds);
                    // verify required parameter 'windowSlideMilliseconds' is not null or undefined
                    (0, common_1.assertParamExists)('getMobHealthWindowedBehaviour', 'windowSlideMilliseconds', windowSlideMilliseconds);
                    localVarPath = "/cow-health/mobs/{mobId}/windowed-health-behaviour"
                        .replace("{".concat("mobId", "}"), encodeURIComponent(String(mobId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    if (windowSizeMilliseconds !== undefined) {
                        localVarQueryParameter['windowSizeMilliseconds'] = windowSizeMilliseconds;
                    }
                    if (windowSlideMilliseconds !== undefined) {
                        localVarQueryParameter['windowSlideMilliseconds'] = windowSlideMilliseconds;
                    }
                    if (lowerRangePercentile !== undefined) {
                        localVarQueryParameter['lowerRangePercentile'] = lowerRangePercentile;
                    }
                    if (upperRangePercentile !== undefined) {
                        localVarQueryParameter['upperRangePercentile'] = upperRangePercentile;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Save health alert monitoring data
         * @param {ICowHealthModelMonitoringDTO} iCowHealthModelMonitoringDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCowHealthMonitoringDTO: function (iCowHealthModelMonitoringDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCowHealthModelMonitoringDTO' is not null or undefined
                    (0, common_1.assertParamExists)('saveCowHealthMonitoringDTO', 'iCowHealthModelMonitoringDTO', iCowHealthModelMonitoringDTO);
                    localVarPath = "/cattle-breeding/monitoring-data/health-model";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCowHealthModelMonitoringDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Saves diagnoses for a health-case
         * @param {ISaveDiagnosisDTO} iSaveDiagnosisDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDiagnoses: function (iSaveDiagnosisDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iSaveDiagnosisDTO' is not null or undefined
                    (0, common_1.assertParamExists)('saveDiagnoses', 'iSaveDiagnosisDTO', iSaveDiagnosisDTO);
                    localVarPath = "/cow-health/health-case/save-diagnoses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSaveDiagnosisDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update health case statuses to recovered if conditions are met
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHealthCaseStatuses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/update-health-case-statuses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upserts an entry to the cow health timeline for the given day
         * @param {IUpsertCowHealthTimelineEntryDTO} [iUpsertCowHealthTimelineEntryDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHealthTimelineEntry: function (iUpsertCowHealthTimelineEntryDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-health/timeline";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertCowHealthTimelineEntryDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Deletes a manually created health-case that is unknown to the model
         * @param {string} healthCaseId The ID of the health case to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthCase: function (healthCaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteManualHealthCase(healthCaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a manually created cow health timeline
         * @param {string} timelineEntryid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthTimelineEntry: function (timelineEntryid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteManualHealthTimelineEntry(timelineEntryid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Flags a cow as sick through system report. This is the old method and will be deprecated in favor of flagSickCow
         * @param {ICowFlaggedEventDTO} [iCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        flagCow: function (iCowFlaggedEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.flagCow(iCowFlaggedEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Flags a cow as sick from the Health 2.0 model
         * @param {ISickCowFlaggedEventDTO} [iSickCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagSickCow: function (iSickCowFlaggedEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.flagSickCow(iSickCowFlaggedEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets the number of health cases that the farmer needs to check immediately
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckImmediatelyCount: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCheckImmediatelyCount(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve list of cow behaviour total minutes for passed in list of cattleIds
         * @param {ICowBehaviourTotalMinutesForCattleIdsRequestDTO} iCowBehaviourTotalMinutesForCattleIdsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowBehaviourTotalMinutesForCattleIds: function (iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowBehaviourTotalMinutesForCattleIds(iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow. Will be deprecated and replaced with /windowed-health-behaviour in June 2023
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthBehaviour: function (cattleId, from, to, intervalPeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowHealthBehaviour(cattleId, from, to, intervalPeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves health cases for a cow
         * @param {string} cattleId The ID of the cow to retrieve health cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthCases: function (cattleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowHealthCases(cattleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow aggregated in windows of time
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthWindowedBehaviour: function (cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowHealthWindowedBehaviour(cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves cows currently in calving recovery
         * @param {string} [cattleId] The ID of the cow to retrieve calving recovery data for
         * @param {boolean} [allResults] Defaults to false if undefined. If true then send all results with no 21 day cut off
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsInCalvingRecovery: function (cattleId, allResults, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowsInCalvingRecovery(cattleId, allResults, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets the current health cases that are both diagnosed and not yet diagnosed in a summary form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSummaryHealthCases: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCurrentSummaryHealthCases(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve sick cows grouped by duration of illness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDurationOfIllnessHealthTimeline: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDurationOfIllnessHealthTimeline(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Fetches the latest state of a health case
         * @param {string} healthCaseId The ID of the health case to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCaseById: function (healthCaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHealthCaseById(healthCaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves sick cow timeline entries.
         * @param {number} [limit] Number of timeline entries in response. If less than this number returned, more statuses do not exist.
         * @param {number} [offset]
         * @param {string} [cattleId] Limit the results to a particular cattle id
         * @param {Array<SicknessTypeEnum>} [sicknessTypes] Limit the results to particular sickness types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthTimeline: function (limit, offset, cattleId, sicknessTypes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHealthTimeline(limit, offset, cattleId, sicknessTypes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets the historical health cases in a paged response
         * @param {number} [currentOffset]
         * @param {any} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricHealthCases: function (currentOffset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHistoricHealthCases(currentOffset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthBehaviour: function (mobId, from, to, intervalPeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMobHealthBehaviour(mobId, from, to, intervalPeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob in sliding windows.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {number} [lowerRangePercentile] Lower boundary percentile of the cows in the mob to calculate for the rangeLower
         * @param {number} [upperRangePercentile] Upper boundary percentile of the cows in the mob to calculate for the rangeUpper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthWindowedBehaviour: function (mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMobHealthWindowedBehaviour(mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Save health alert monitoring data
         * @param {ICowHealthModelMonitoringDTO} iCowHealthModelMonitoringDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCowHealthMonitoringDTO: function (iCowHealthModelMonitoringDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveCowHealthMonitoringDTO(iCowHealthModelMonitoringDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Saves diagnoses for a health-case
         * @param {ISaveDiagnosisDTO} iSaveDiagnosisDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDiagnoses: function (iSaveDiagnosisDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveDiagnoses(iSaveDiagnosisDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update health case statuses to recovered if conditions are met
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHealthCaseStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateHealthCaseStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upserts an entry to the cow health timeline for the given day
         * @param {IUpsertCowHealthTimelineEntryDTO} [iUpsertCowHealthTimelineEntryDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHealthTimelineEntry: function (iUpsertCowHealthTimelineEntryDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertHealthTimelineEntry(iUpsertCowHealthTimelineEntryDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary Deletes a manually created health-case that is unknown to the model
         * @param {string} healthCaseId The ID of the health case to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthCase: function (healthCaseId, options) {
            return localVarFp.deleteManualHealthCase(healthCaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a manually created cow health timeline
         * @param {string} timelineEntryid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualHealthTimelineEntry: function (timelineEntryid, options) {
            return localVarFp.deleteManualHealthTimelineEntry(timelineEntryid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Flags a cow as sick through system report. This is the old method and will be deprecated in favor of flagSickCow
         * @param {ICowFlaggedEventDTO} [iCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        flagCow: function (iCowFlaggedEventDTO, options) {
            return localVarFp.flagCow(iCowFlaggedEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Flags a cow as sick from the Health 2.0 model
         * @param {ISickCowFlaggedEventDTO} [iSickCowFlaggedEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagSickCow: function (iSickCowFlaggedEventDTO, options) {
            return localVarFp.flagSickCow(iSickCowFlaggedEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets the number of health cases that the farmer needs to check immediately
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckImmediatelyCount: function (options) {
            return localVarFp.getCheckImmediatelyCount(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve list of cow behaviour total minutes for passed in list of cattleIds
         * @param {ICowBehaviourTotalMinutesForCattleIdsRequestDTO} iCowBehaviourTotalMinutesForCattleIdsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowBehaviourTotalMinutesForCattleIds: function (iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options) {
            return localVarFp.getCowBehaviourTotalMinutesForCattleIds(iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow. Will be deprecated and replaced with /windowed-health-behaviour in June 2023
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthBehaviour: function (cattleId, from, to, intervalPeriod, options) {
            return localVarFp.getCowHealthBehaviour(cattleId, from, to, intervalPeriod, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves health cases for a cow
         * @param {string} cattleId The ID of the cow to retrieve health cases for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthCases: function (cattleId, options) {
            return localVarFp.getCowHealthCases(cattleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a specific cow aggregated in windows of time
         * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowHealthWindowedBehaviour: function (cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options) {
            return localVarFp.getCowHealthWindowedBehaviour(cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves cows currently in calving recovery
         * @param {string} [cattleId] The ID of the cow to retrieve calving recovery data for
         * @param {boolean} [allResults] Defaults to false if undefined. If true then send all results with no 21 day cut off
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsInCalvingRecovery: function (cattleId, allResults, options) {
            return localVarFp.getCowsInCalvingRecovery(cattleId, allResults, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets the current health cases that are both diagnosed and not yet diagnosed in a summary form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSummaryHealthCases: function (options) {
            return localVarFp.getCurrentSummaryHealthCases(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve sick cows grouped by duration of illness.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDurationOfIllnessHealthTimeline: function (options) {
            return localVarFp.getDurationOfIllnessHealthTimeline(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Fetches the latest state of a health case
         * @param {string} healthCaseId The ID of the health case to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCaseById: function (healthCaseId, options) {
            return localVarFp.getHealthCaseById(healthCaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves sick cow timeline entries.
         * @param {number} [limit] Number of timeline entries in response. If less than this number returned, more statuses do not exist.
         * @param {number} [offset]
         * @param {string} [cattleId] Limit the results to a particular cattle id
         * @param {Array<SicknessTypeEnum>} [sicknessTypes] Limit the results to particular sickness types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthTimeline: function (limit, offset, cattleId, sicknessTypes, options) {
            return localVarFp.getHealthTimeline(limit, offset, cattleId, sicknessTypes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets the historical health cases in a paged response
         * @param {number} [currentOffset]
         * @param {any} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricHealthCases: function (currentOffset, limit, options) {
            return localVarFp.getHistoricHealthCases(currentOffset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthBehaviour: function (mobId, from, to, intervalPeriod, options) {
            return localVarFp.getMobHealthBehaviour(mobId, from, to, intervalPeriod, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve time-series of cow health behaviour for a mob in sliding windows.
         * @param {string} mobId The ID of the mob to retrieve behaviour data for.
         * @param {Date} from Beginning of the time-range to return data for, inclusive.
         * @param {Date} to End of the time-range to return data for, exclusive.
         * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
         * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
         * @param {number} [lowerRangePercentile] Lower boundary percentile of the cows in the mob to calculate for the rangeLower
         * @param {number} [upperRangePercentile] Upper boundary percentile of the cows in the mob to calculate for the rangeUpper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobHealthWindowedBehaviour: function (mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options) {
            return localVarFp.getMobHealthWindowedBehaviour(mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save health alert monitoring data
         * @param {ICowHealthModelMonitoringDTO} iCowHealthModelMonitoringDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCowHealthMonitoringDTO: function (iCowHealthModelMonitoringDTO, options) {
            return localVarFp.saveCowHealthMonitoringDTO(iCowHealthModelMonitoringDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Saves diagnoses for a health-case
         * @param {ISaveDiagnosisDTO} iSaveDiagnosisDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDiagnoses: function (iSaveDiagnosisDTO, options) {
            return localVarFp.saveDiagnoses(iSaveDiagnosisDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update health case statuses to recovered if conditions are met
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHealthCaseStatuses: function (options) {
            return localVarFp.updateHealthCaseStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upserts an entry to the cow health timeline for the given day
         * @param {IUpsertCowHealthTimelineEntryDTO} [iUpsertCowHealthTimelineEntryDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHealthTimelineEntry: function (iUpsertCowHealthTimelineEntryDTO, options) {
            return localVarFp.upsertHealthTimelineEntry(iUpsertCowHealthTimelineEntryDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Deletes a manually created health-case that is unknown to the model
     * @param {string} healthCaseId The ID of the health case to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteManualHealthCase = function (healthCaseId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteManualHealthCase(healthCaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a manually created cow health timeline
     * @param {string} timelineEntryid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteManualHealthTimelineEntry = function (timelineEntryid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteManualHealthTimelineEntry(timelineEntryid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Flags a cow as sick through system report. This is the old method and will be deprecated in favor of flagSickCow
     * @param {ICowFlaggedEventDTO} [iCowFlaggedEventDTO]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.flagCow = function (iCowFlaggedEventDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).flagCow(iCowFlaggedEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Flags a cow as sick from the Health 2.0 model
     * @param {ISickCowFlaggedEventDTO} [iSickCowFlaggedEventDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.flagSickCow = function (iSickCowFlaggedEventDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).flagSickCow(iSickCowFlaggedEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets the number of health cases that the farmer needs to check immediately
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCheckImmediatelyCount = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCheckImmediatelyCount(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve list of cow behaviour total minutes for passed in list of cattleIds
     * @param {ICowBehaviourTotalMinutesForCattleIdsRequestDTO} iCowBehaviourTotalMinutesForCattleIdsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCowBehaviourTotalMinutesForCattleIds = function (iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCowBehaviourTotalMinutesForCattleIds(iCowBehaviourTotalMinutesForCattleIdsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve time-series of cow health behaviour for a specific cow. Will be deprecated and replaced with /windowed-health-behaviour in June 2023
     * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
     * @param {Date} from Beginning of the time-range to return data for, inclusive.
     * @param {Date} to End of the time-range to return data for, exclusive.
     * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCowHealthBehaviour = function (cattleId, from, to, intervalPeriod, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCowHealthBehaviour(cattleId, from, to, intervalPeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves health cases for a cow
     * @param {string} cattleId The ID of the cow to retrieve health cases for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCowHealthCases = function (cattleId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCowHealthCases(cattleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve time-series of cow health behaviour for a specific cow aggregated in windows of time
     * @param {string} cattleId The ID of the cow to retrieve behaviour data for.
     * @param {Date} from Beginning of the time-range to return data for, inclusive.
     * @param {Date} to End of the time-range to return data for, exclusive.
     * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
     * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCowHealthWindowedBehaviour = function (cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCowHealthWindowedBehaviour(cattleId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves cows currently in calving recovery
     * @param {string} [cattleId] The ID of the cow to retrieve calving recovery data for
     * @param {boolean} [allResults] Defaults to false if undefined. If true then send all results with no 21 day cut off
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCowsInCalvingRecovery = function (cattleId, allResults, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCowsInCalvingRecovery(cattleId, allResults, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets the current health cases that are both diagnosed and not yet diagnosed in a summary form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCurrentSummaryHealthCases = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCurrentSummaryHealthCases(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve sick cows grouped by duration of illness.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDurationOfIllnessHealthTimeline = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDurationOfIllnessHealthTimeline(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Fetches the latest state of a health case
     * @param {string} healthCaseId The ID of the health case to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHealthCaseById = function (healthCaseId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getHealthCaseById(healthCaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves sick cow timeline entries.
     * @param {number} [limit] Number of timeline entries in response. If less than this number returned, more statuses do not exist.
     * @param {number} [offset]
     * @param {string} [cattleId] Limit the results to a particular cattle id
     * @param {Array<SicknessTypeEnum>} [sicknessTypes] Limit the results to particular sickness types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHealthTimeline = function (limit, offset, cattleId, sicknessTypes, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getHealthTimeline(limit, offset, cattleId, sicknessTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets the historical health cases in a paged response
     * @param {number} [currentOffset]
     * @param {any} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHistoricHealthCases = function (currentOffset, limit, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getHistoricHealthCases(currentOffset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve time-series of cow health behaviour for a mob.
     * @param {string} mobId The ID of the mob to retrieve behaviour data for.
     * @param {Date} from Beginning of the time-range to return data for, inclusive.
     * @param {Date} to End of the time-range to return data for, exclusive.
     * @param {BehaviourIntervalPeriodEnum} [intervalPeriod] Interval period to return data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMobHealthBehaviour = function (mobId, from, to, intervalPeriod, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getMobHealthBehaviour(mobId, from, to, intervalPeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve time-series of cow health behaviour for a mob in sliding windows.
     * @param {string} mobId The ID of the mob to retrieve behaviour data for.
     * @param {Date} from Beginning of the time-range to return data for, inclusive.
     * @param {Date} to End of the time-range to return data for, exclusive.
     * @param {number} windowSizeMilliseconds Duration of the window to aggregate the behaviors
     * @param {number} windowSlideMilliseconds How often to move the window to aggregate the behaviors
     * @param {number} [lowerRangePercentile] Lower boundary percentile of the cows in the mob to calculate for the rangeLower
     * @param {number} [upperRangePercentile] Upper boundary percentile of the cows in the mob to calculate for the rangeUpper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getMobHealthWindowedBehaviour = function (mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getMobHealthWindowedBehaviour(mobId, from, to, windowSizeMilliseconds, windowSlideMilliseconds, lowerRangePercentile, upperRangePercentile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save health alert monitoring data
     * @param {ICowHealthModelMonitoringDTO} iCowHealthModelMonitoringDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.saveCowHealthMonitoringDTO = function (iCowHealthModelMonitoringDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).saveCowHealthMonitoringDTO(iCowHealthModelMonitoringDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Saves diagnoses for a health-case
     * @param {ISaveDiagnosisDTO} iSaveDiagnosisDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.saveDiagnoses = function (iSaveDiagnosisDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).saveDiagnoses(iSaveDiagnosisDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update health case statuses to recovered if conditions are met
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateHealthCaseStatuses = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateHealthCaseStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upserts an entry to the cow health timeline for the given day
     * @param {IUpsertCowHealthTimelineEntryDTO} [iUpsertCowHealthTimelineEntryDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.upsertHealthTimelineEntry = function (iUpsertCowHealthTimelineEntryDTO, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).upsertHealthTimelineEntry(iUpsertCowHealthTimelineEntryDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
